/* eslint-disable no-magic-numbers */
import logger from './util-logger';

// global variables
const dev =  window.location.origin.indexOf('kinetiq.network') > -1 || window.location.origin.indexOf('localhost') > -1;

if (dev) {
    logger.info('dev');
}

const domain = dev ? 'https://d21jvqwi9ccksi.cloudfront.net' : '';

const loginEndpoint = domain + '/api/auth/login';
const logoutEndpoint = domain + '/api/auth/logout';
const dimensionEndpoint = domain + '/api/dimension/list';
const projectEndpoint = domain + '/api/campaign/list';
const projectDetailsEndpoint = domain + '/api/campaign/get';
const projectDownloadEndpoint = domain + '/api/campaign/download';
const projectCreateEndpoint = domain + '/api/campaign/create';
const projectEditEndpoint = domain + '/api/campaign/edit';
const projectDeleteCampaign = domain + '/api/campaign/delete';
const projectPlacementCreateEndpoint = domain + '/api/campaign/placement/create';
const projectPlacementEditEndpoint = domain + '/api/campaign/placement/edit';
const projectDeletePlacement = domain + '/api/campaign/placement/delete';
const projectCreativeCreateEndpoint = domain + '/api/campaign/creative/create';
const projectCreativeEditEndpoint = domain + '/api/campaign/creative/edit';
const projectDeleteCreative = domain + '/api/campaign/creative/delete';
const projectAdgroupCreateEndpoint = domain + '/api/campaign/adgroup/create';
const projectAdgroupEditEndpoint = domain + '/api/campaign/adgroup/edit';
const projectDeleteAdgroup = domain + '/api/campaign/adgroup/delete';
const projectEmailEndpoint = domain + '/api/campaign/email/create';
const projectEmailEditEndpoint = domain + '/api/campaign/email/edit';
const projectDeleteEmail = domain + '/api/campaign/email/delete';

// global endpoint variables
export {
    loginEndpoint,
    logoutEndpoint,
    dimensionEndpoint,
    projectEndpoint,
    projectDetailsEndpoint,
    projectDownloadEndpoint,
    projectCreateEndpoint,
    projectEditEndpoint,
    projectDeleteCampaign,
    projectPlacementCreateEndpoint,
    projectPlacementEditEndpoint,
    projectDeletePlacement,
    projectCreativeCreateEndpoint,
    projectCreativeEditEndpoint,
    projectDeleteAdgroup,
    projectAdgroupCreateEndpoint,
    projectAdgroupEditEndpoint,
    projectDeleteEmail,
    projectEmailEndpoint,
    projectEmailEditEndpoint,
    projectDeleteCreative,
};
